import BasicInput from '@shared/ui/forms/inputs/BasicInput';
import { emailRule } from '@utils/validation';
import { useTranslation } from 'react-i18next';
import { useEditEmailDialog } from '@utils/dialogs-hooks';

export default function EmailInput({
  control,
  errors,
  disabled,
  changeAction = false,
  name = 'email',
}) {
  const { t } = useTranslation();
  const { openEditEmailDialog } = useEditEmailDialog();

  return (
    <BasicInput
      control={control}
      name={name}
      label={t('email')}
      validation={emailRule}
      error={errors[name]}
      placeholder={t('email_placeholder')}
      icon="email-input"
      disabled={disabled}
      onButtonClick={changeAction ? openEditEmailDialog : undefined}
      buttonIcon="refresh"
    />
  );
}
